import { withAITracking } from '@microsoft/applicationinsights-react-js';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { reactAI } from 'services/telemetry-service';
import { getUsersSuperAdminGroupsChildHierarchy } from 'state/ducks/groups/operations';
import { Routes } from 'state/ducks/routes';
import history from 'state/history';
import { localized } from 'state/i18n';
import { AppState } from 'state/store';
import { isAtLeastSuperAdminFromState } from 'utilities/roles-util';
import { getEmailFromToken } from 'utilities/token-util';
import { cardGeneralClassNames } from 'view/components/table/details/constants';
import { BiTabPanel, BiTabView } from 'view/shared/components/bi-tabview/bi-tabview';
import BiTitle from 'view/shared/components/bi-title/bi-title';
import { AvailableElementsForStyling } from 'view/shared/components/cards/white-card';
import ResponsiveSpacingWrapper from 'view/shared/components/responsive-wrappers/responsive-spacing-wrapper';
import './adminstration.scss';
import BaseAdministrationPage from './pages/base-administration-page';
import MachineLearningAdministrationPage from './pages/machine-learning-administration-page';

export const ProfileCardDoubleContainerLength: AvailableElementsForStyling = {
	classNameTitle: '',
	classNameSubtitle: '',
	classNameContainer: `${cardGeneralClassNames.classNameContainer} flex-fill-remaining-space 
      card-width-1300-and-margin-spacing flex-direction-column`,
};

const mapStateToProps = (state: AppState) => {
	const usersCountryAdminGroups = state.groupsReducer.countryAdminGroups.find(g => g.id === getEmailFromToken());

	const isCountryAdmin: boolean = !!usersCountryAdminGroups?.data?.length;
	const isSuperAdmin: boolean = isAtLeastSuperAdminFromState(state);

	const isServiceToolCode =
		isCountryAdmin || state.userPermissionReducer.UserGroupPermissions.some(ugp => ugp.isServiceToolCode);

	return {
		isCountryAdmin,
		isSuperAdmin,
		isServiceToolCode,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getUsersSuperAdminGroupsChildHierarchy: async () => (await getUsersSuperAdminGroupsChildHierarchy())(dispatch),
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

type State = {
	showNewReleaseNoteDialog: boolean;
	showServiceTechnicianVideoDialog: boolean;
	generateServiceCodeDialogVisible: boolean;
	activeTab: number;
};

const tabUrlRecord: Record<number, string> = {
	0: Routes.Administration,
	1: Routes.AdminMl,
};

const urlContentRecord: Record<string, JSX.Element> = {
	[Routes.Administration]: <BaseAdministrationPage />,
	[Routes.AdminMl]: <MachineLearningAdministrationPage />,
};

class AdministrationPage extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			showNewReleaseNoteDialog: false,
			showServiceTechnicianVideoDialog: false,
			generateServiceCodeDialogVisible: false,
			activeTab: 0,
		};
		this.props.getUsersSuperAdminGroupsChildHierarchy();
	}
	private tabPanels = [
		<BiTabPanel header="Administration" key="Admin"></BiTabPanel>,
		...(this.props.isSuperAdmin ? [<BiTabPanel header="Machine Learning" key="ML"></BiTabPanel>] : []),
	];

	public render() {
		let currentPage = urlContentRecord[tabUrlRecord[this.state?.activeTab ?? 0]];
		return (
			<BiTitle title={localized('Administration')}>
				<div>
					<ResponsiveSpacingWrapper>
						<div className="margin-horizontal-page-normal">
							<div className="flex-direction-row margin-top-40 margin-bottom-20 flex-space-between-row">
								<h1 className="text-bold">{localized('Administration')}</h1>
							</div>
							{this.tabPanels.length > 1 && (
								<BiTabView
									key={'tab-view'}
									activeIndex={this.state.activeTab}
									onTabChange={this.changeTabView}
								>
									{this.tabPanels}
								</BiTabView>
							)}
							{currentPage}
						</div>
					</ResponsiveSpacingWrapper>
				</div>
			</BiTitle>
		);
	}

	private changeTabView = (e: { index: number }) => {
		this.setState({ activeTab: e.index });
		history.push(tabUrlRecord[e.index]);
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withAITracking(reactAI.reactPlugin, AdministrationPage, 'Administration'));
